import React from 'react'
import { Button, Col } from 'reactstrap'
import { withTranslation } from 'react-i18next'
import { ArrowCircleRight } from "phosphor-react"
import PropTypes from 'prop-types'
import Skeleton from '../UI/Skeleton'

class StudyMiniCard extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            // eslint-disable-next-line no-undef
            imageUrl: process.env.REACT_APP_IMAGEURL,
        }
        this.readMore = this.readMore.bind(this)
    }

    readMore() {
        this.props.props.history.push(`/item/${this.props.id}`)
        window.location.reload()
    }

    render() {
        const { t } = this.props
        return (
            <Col xl={this.props.cols || 4} lg={6} md={6} sm={12}>
                {
                    this.props.skeleton ?

                        <div className="card mini">
                            <Skeleton className="card-img mini" height={200} />
                            <div className="card-body catalog-card-body py-20 px-2">
                                <Skeleton className="card-title lg-font-size my-0" />
                                <Skeleton className="card-title lg-font-size" />
                                <Skeleton className="card-desc md-font-size" count={5} />
                            </div>
                        </div>

                        :
                        <div className="card mini">
                            <img className="card-img mini" src={this.props.image ? `${this.state.imageUrl}/${this.props.image}` : "data:,"} alt=""></img>
                            <div className="catalog-type xs-font-size">{t(`course-type-${this.props.typeId}`)}</div>
                            <div className={`card-body catalog-card-body${this.props.courseType === 'program' ? ' py-20 px-20' : ''}`}>
                                <div className="card-title lg-font-size">{this.props.title}</div>
                                <div className="card-desc md-font-size" dangerouslySetInnerHTML={{ __html: this.props.desc }}></div>
                                {this.props.courseType === 'program' ? '' : <div className="card-whitespace"></div>}
                            </div>
                            {
                                this.props.courseType === 'program' ? '' :
                                    <div className="card-bottom catalog-card-bottom">
                                        <div className="card-price">
                                            <span className="card-price-text xs-font-size">{t('catalog-cost')}</span>
                                            <span className="card-price-amount md-font-size">{this.props.price} USDU</span>
                                        </div>
                                        <Button type="button" className="card-button" onClick={this.readMore}>
                                            <ArrowCircleRight size={20} className="primary-color" />
                                            <span className="card-button-text sm-font-size">{t('catalog-read-more')}</span>
                                        </Button>
                                    </div>
                            }
                        </div>
                }
            </Col>
        )
    }
}

StudyMiniCard.propTypes = {
    props: PropTypes.object,
    t: PropTypes.func,
    id: PropTypes.string,
    image: PropTypes.string,
    title: PropTypes.string,
    desc: PropTypes.string,
    price: PropTypes.string,
    cols: PropTypes.string,
    typeId: PropTypes.number,
    courseType: PropTypes.string,
    skeleton: PropTypes.bool,
}

export default withTranslation()(StudyMiniCard)



// WEBPACK FOOTER //
// ./src/components/Catalog/CatalogMiniCard.jsx